/** Below this many available cloud units the chat composer shows a low-balance warning. */
export const LOW_CLOUD_UNITS_THRESHOLD = 1_000_000

/**
 * - `unknown`: balance not loaded (or the fetch failed) — the backend gate decides.
 * - `empty`: no units left; new chat turns are blocked.
 * - `low`: under {@link LOW_CLOUD_UNITS_THRESHOLD}; still usable, show a warning.
 */
export type CloudUnitsStatus = 'unknown' | 'ok' | 'low' | 'empty'

export function getCloudUnitsStatus(balance: number | null | undefined): CloudUnitsStatus {
  if (balance === null || balance === undefined) return 'unknown'
  if (balance <= 0) return 'empty'
  if (balance < LOW_CLOUD_UNITS_THRESHOLD) return 'low'
  return 'ok'
}

/** Whether the chat may start a new turn. Blocks only on a balance known to be empty. */
export function canStartChatTurn(balance: number | null | undefined): boolean {
  return getCloudUnitsStatus(balance) !== 'empty'
}
